import React, { useState, useEffect } from 'react'
import { Message, TransitionablePortal } from 'semantic-ui-react'

export interface Props {
  errorMessages?: string[]
  infoMessages?: string[]
  successMessages?: string[]
  dismissable?: boolean
  compact?: boolean
  onClose?: () => void
}
export const MessageCenter = ({
  errorMessages = [],
  infoMessages = [],
  successMessages = [],
  dismissable = true,
  compact = false,
  onClose
}: Props) => {
  const [errorVisible, setErrorVisible] = useState(true)
  const [successVisible, setSuccessVisible] = useState(true)
  const [infoVisible, setInfoVisible] = useState(true)

  useEffect(() => {
    setErrorVisible(true)
  }, [errorMessages])

  useEffect(() => {
    setSuccessVisible(true)
  }, [successMessages])

  useEffect(() => {
    setInfoVisible(true)
  }, [infoMessages])

  // This is to handle the closure of success message after a set time.
  const handleOnOpen = () => {
    setTimeout(() => handleOnClose(), 7000)
  }

  const handleOnClose = () => {
    if (dismissable) {
      setSuccessVisible(false)
      onClose?.()
    }
  }

  return (
    <>
      {successMessages?.length > 0 && (
        <TransitionablePortal open={successVisible} onOpen={handleOnOpen} onClose={handleOnClose}>
          <Message compact={compact} success onDismiss={handleOnClose}>
            <Message.Header>Success</Message.Header>
            <Message.Content>
              {successMessages.map((message, index) => (
                <p key={`successmsg-${index}`}>{message}</p>
              ))}
            </Message.Content>
          </Message>
        </TransitionablePortal>
      )}
      {errorMessages?.length > 0 && (
        <Message
          compact={compact}
          error
          hidden={!errorVisible}
          onDismiss={dismissable ? () => setErrorVisible(false) : undefined}
        >
          <Message.Header>Error</Message.Header>
          <Message.Content>
            {errorMessages.map((message, index) => (
              <p key={`errmsg-${index}`}>{message}</p>
            ))}
          </Message.Content>
        </Message>
      )}
      {infoMessages?.length > 0 && (
        <Message compact={compact} info hidden={!infoVisible}>
          <Message.Content>
            {infoMessages.map((message, index) => (
              <p key={`infomsg-${index}`}>{message}</p>
            ))}
          </Message.Content>
        </Message>
      )}
    </>
  )
}
